import React, { useState, createContext, useEffect } from 'react';
import Client from 'shopify-buy';
import { Sentry } from 'react-activity';
import 'react-activity/dist/react-activity.css';

export const ProductsContext = createContext([]);
export const CheckoutsContext = createContext([]);
export const ShopsContext = createContext([]);
export const CartContext = createContext([]);

const getParamsValue = (attribute) => {
  const urlSearch = window.location.search.replace("?", "");
  if (urlSearch.indexOf(attribute) === -1) {
    return null;
  }
  const splitArray = urlSearch.split(`${attribute}=`)

  let value = null;
  if (splitArray[1]) {
    value = splitArray[1].split('&')[0];
  }
  return value;
}

const client = Client.buildClient({
  domain: 'cmcdreamcar.myshopify.com',
  storefrontAccessToken: 'a775b5a9bedee1fd3439a92bb94ca33c'
});

export const ProductProvider = (props) => {

  const [collection1, setCollection1] = useState(null)
  const [collection2, setCollection2] = useState(null)
  const [collection3, setCollection3] = useState(null)
  const [customCollection, setCustomCollection] = useState(null)

  const [hats, setHats] = useState(localStorage.getItem("hats") ? JSON.parse(localStorage.getItem("hats")) : [])
  const [accessarries, setAccessarries] = useState(localStorage.getItem("accessarries") ? JSON.parse(localStorage.getItem("accessarries")) : [])
  const [shirts, setShirts] = useState(localStorage.getItem("shirts") ? JSON.parse(localStorage.getItem("shirts")) : [])
  const [customCollectionData, setCustomCollectionData] = useState(localStorage.getItem("customCollectionData") ? JSON.parse(localStorage.getItem("customCollectionData")) : [])

  const [checkout, setCheckout] = useState([])
  const [showCart, setShowCart] = useState(false)

  const [shop, setShop] = useState([])
  
  const [renderData, setRenderData] = useState(false)
  

  // // Fetch all collections, including their products
  // client.collection.fetchAllWithProducts().then((collections) => {
  //   // Do something with the collections
  //   console.log(collections);
  // });


  // client.product.fetchAll().then((products) => {  
  //   // Do something with the products
  //   console.log(products);
  // });

  // // Fetch all collections, including their products
  // client.collection.fetchAllWithProducts().then((collections) => {
  //   // Do something with the collections
  //   console.log(collections);
  // });



  useEffect(() => {        
  },[getParamsValue('id')]);

  

  useEffect(() => {

    setRenderData(false)

    client.checkout.create().then((res) => {
      setCheckout(localStorage.getItem("cart") ? JSON.parse(localStorage.getItem("cart")) : res)

      if(getParamsValue('id')) {
        client.collection.fetchWithProducts(`gid://shopify/Collection/${getParamsValue('id')}`, {productsFirst: 200}).then((custom_collection) => {
          setCustomCollection(custom_collection);
          setCustomCollectionData(custom_collection.products)
          localStorage.setItem("customCollectionData", JSON.stringify(custom_collection.products))
        });
      }

      client.collection.fetchWithProducts("gid://shopify/Collection/448065700137", {productsFirst: 200}).then((collection1) => {
        setCollection1(collection1);
        setHats(collection1.products);
        localStorage.setItem("hats", JSON.stringify(collection1.products))

        client.collection.fetchWithProducts("gid://shopify/Collection/448065863977", {productsFirst: 200}).then((collection2) => {
          setCollection2(collection2);
          setShirts(collection2.products);
          localStorage.setItem("shirts", JSON.stringify(collection2.products))

          client.collection.fetchWithProducts("gid://shopify/Collection/448066027817", {productsFirst: 200}).then((collection3) => {
            setCollection3(collection3);
            setAccessarries(collection3.products);
            localStorage.setItem("accessarries", JSON.stringify(collection3.products))

            client.shop.fetchInfo().then((res) => {
              setShop(res);
              setRenderData(true);
            });

          });

        });

      });
      
    });

  }, [getParamsValue('id')]);

  if (renderData) {
    return (
      <ProductsContext.Provider value={{ 
        hats: hats, 
        shirts: shirts, 
        accessarries: accessarries, 
        customCollectionData: customCollectionData,
        collection1: collection1, 
        collection2: collection2, 
        collection3: collection3,
        customCollection: customCollection
      }}>
        <CheckoutsContext.Provider value={[checkout, setCheckout]}>
          <ShopsContext.Provider value={shop}>
            <CartContext.Provider value={[showCart, setShowCart]}>
              {props.children}
            </CartContext.Provider>
          </ShopsContext.Provider>
        </CheckoutsContext.Provider>
      </ProductsContext.Provider>
    )
  }
  else {
    return (
      <div style={{ height: "100vh", textAlign: "center", overflow: "hidden" }} className="loader-bg">
        <Sentry />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/products/productsContext.js